import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    active: 'empty'
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TESTBENCH__SET_ENV':
            return core.setEnv(state, action.environment);
        case 'TESTBENCH__SET_ENVIRONMENTS_CONFIG':
            return core.setEnvsConfig(state, action.environments);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Environments/reducer.js